import {PlainTextOrHtml, utils, formattedPropertyModel} from '@wallaby-ui/core';
import * as React from 'react';
import {useIntl} from 'react-intl';

import styles from './DocumentHeader.less';

interface OwnProps {
  title: string;
  subTitle?: string;
  documentTimeStamp?: string;
}

type Props = OwnProps;

export const DocumentHeader: React.FC<Props> = (props) => {
  const {title, subTitle, documentTimeStamp} = props;
  const intl = useIntl();

  const translatedTitle = utils.TranslateUtils.translate(title, intl);
  const translatedSubTitle = subTitle
    ? utils.TranslateUtils.translate(subTitle, intl)
    : null;
  const propDefinition = new formattedPropertyModel.FormattedProperty({
    type: formattedPropertyModel.FORMATTED_PROPERTY_TYPE_DATETIME,
  });
  const formattedDocumentTimestamp = documentTimeStamp
    ? formattedPropertyModel.FormattedProperty.formatValue(
        propDefinition,
        documentTimeStamp,
        intl
      )
    : null;
  const documentSubtitle = formattedDocumentTimestamp || translatedSubTitle;
  return (
    <div className={styles.dlDocumentHeader}>
      {(title && subTitle) || (title && documentTimeStamp) ? (
        <div className={styles.dlDocumentTitleWrapper}>
          <i className={'far fa-file-alt'} />
          <span
            className={styles.dlDocumentTitle}
            title={translatedTitle}
            data-name={'renderedDocumentTitle'}
          >
            <PlainTextOrHtml text={translatedTitle} showHtml />
          </span>
          {documentSubtitle ? (
            <span>
              <span className={styles.dlDocumentSubTitlePadding}>-</span>
              <span
                className={styles.dlDocumentSubTitlePadding}
                title={translatedSubTitle}
                data-name={'renderedDocumentSubTitle'}
              >
                <PlainTextOrHtml text={documentSubtitle} showHtml />
              </span>
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

DocumentHeader.displayName = 'DocumentHeader';
